import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import Modal from "react-bootstrap/Modal";
import PopUp from "../../components/popUp";

function Banner(props) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div className="experienced p-100">
        <Container className="h-100">
          <Row className="h-100">
            <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
              <h2>Unity Game Development Company in Dubai</h2>
              <p>
                Unity is among the most popular game development platforms known
                around the globe, used by millions of developers worldwide to
                build exquisite games. Unity is TekRevol’s first choice in game
                development projects like many others due to its unique features
                and functions.
              </p>
              <p>
                TekRevol has built multiple mobile game apps using Unity, and
                the suite of options that it provides and the freedom it allows
                while developing the game make it the most favorable when
                beginning a game development project. As a leading game
                development company in Dubai, we can say that Unity is
                undoubtedly one of the best bets when developing a game. When
                you hire game developers from us, you hire individuals with
                plenty of experience developing world-class 2D and 3D games
                using Unity.
              </p>
              <button
                onClick={handleShow}
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Build Your Game App
              </button>
            </Col>
            <Col
              xs={12}
              md={6}
              lg={6}
              xl={6}
              xxl={6}
              className="my-auto text-center offset-lg-1 mt-4 mt-md-0"
            >
              <StaticImage
                src="../../../images/locationgcc/game/unity-game-dubai.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={876}
                height={853}
              />
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-popup"
      >
        <div className="modal_forms">
          <PopUp setShow={setShow} />
        </div>
      </Modal>
    </>
  );
}

export default Banner;
